import { blue } from "@mui/material/colors";
import { createTheme } from "@mui/material";

export const appTheme = createTheme({
    palette: {
        secondary: blue,
    },
})